enum SendTaskModalState {
    ChooseFile = 1,
    ConfirmSelection = 2,
    UploadingFile = 3,
    SuccessfullSent = 4,
    ConfirmExit = 5,
    Error = 6,
}export default SendTaskModalState;

